<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions('oidc', [
      'oidcSignInCallback'
    ])
  },
  mounted () {
    // FIXME Huge hack to circumvent the fact that Amazon does not implement OIDC properly
    const url = window.location.href.replace('id_token', 'not_an_id_token')
    this.oidcSignInCallback(url)
      .then((redirectPath) => {
        this.$router.push(redirectPath)
      })
      .catch((err) => {
        console.error(err)
        this.$router.push('/oidc/callback-error') // Handle errors any way you want
      })
  }
}
</script>
